package co.maytes.standupbot.dashboard.features.roster

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import co.maytes.standupbot.dashboard.lib.api.ApiClient
import co.maytes.standupbot.dashboard.lib.api.Result
import co.maytes.standupbot.dashboard.stores.rememberApiClient
import co.maytes.standupbot.shared.dto.standup.MemberLinkReportDto
import co.maytes.standupbot.shared.dto.standup.MemberLinkStatusDto

sealed interface LinkReportState {
    data object Idle : LinkReportState

    data object Loading : LinkReportState

    data class Ready(val report: MemberLinkReportDto) : LinkReportState

    data class Failed(val message: String) : LinkReportState
}

class LinkReportStore(private val api: ApiClient) {
    var state: LinkReportState by mutableStateOf(LinkReportState.Idle)
        private set

    suspend fun load(workspaceId: String, standupId: String) {
        if (state !is LinkReportState.Ready) state = LinkReportState.Loading
        state =
            when (val result = api.get<MemberLinkReportDto>("/api/v1/workspaces/$workspaceId/standups/$standupId/members/link-report")) {
                is Result.Ok -> LinkReportState.Ready(result.value)
                is Result.Err -> LinkReportState.Failed(result.error.displayMessage)
            }
    }

    fun statusOf(userId: String): MemberLinkStatusDto? =
        (state as? LinkReportState.Ready)?.report?.members?.firstOrNull { it.userId == userId }
}

@Composable
fun rememberLinkReportStore(): LinkReportStore {
    val api = rememberApiClient()
    return remember(api) { LinkReportStore(api) }
}
